var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.845,
    height: 150,
    viewBox: "0 0 120.845 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Application_for_best_developer_website",
    "data-name": "Application for best developer website",
    d: "M122.177,98.558a34.011,34.011,0,0,1-14.261,28.732,48.954,48.954,0,0,1-15.423,7.394,67.013,67.013,0,0,1-18.7,2.535H1.332v-150H81.614A29.6,29.6,0,0,1,95.769-9.4,35.339,35.339,0,0,1,106.543-.632a40.181,40.181,0,0,1,6.866,12.254,41.073,41.073,0,0,1-3.063,34.437A33.453,33.453,0,0,1,94.29,60.319a38.566,38.566,0,0,1,20.387,13.627Q122.177,83.769,122.177,98.558ZM92.811,93.065a21.969,21.969,0,0,0-1.373-7.711,21.414,21.414,0,0,0-3.7-6.444,17.22,17.22,0,0,0-5.493-4.331,15.369,15.369,0,0,0-6.972-1.585H30.487V112.5H73.8a19,19,0,0,0,7.5-1.479,17.978,17.978,0,0,0,6.021-4.12,20.062,20.062,0,0,0,5.493-13.838ZM30.487,12.15V49.966H69.36a17.3,17.3,0,0,0,12.57-5.07q5.176-5.07,5.176-13.944,0-8.662-4.754-13.732a15.435,15.435,0,0,0-11.725-5.07Z",
    transform: "translate(-1.332 12.78)",
    fill: "#674188"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/Buyer.456cd98a767acb59f2728ed555ef96a1.svg";
export { ForwardRef as ReactComponent };